
  import { Vue, Component, Prop } from "vue-property-decorator";

  import RatingStars from "@/components/rating/RatingStars.vue";
  import Badge from "@/components/common/Badge.vue";

  import { getContractorRating } from "@/helpers/contractors/getContractorRating";
  import { NOT_RATED } from "@/data/placeholders";

  import { Contractor_Rating_Aggregate } from "@/generated/graphql";
  import BadgeColor from "@/entities/BadgeColor";

  @Component({
    components: {
      RatingStars,
      Badge,
    },
  })
  export default class ContractorRating extends Vue {
    @Prop({ type: Object, required: true }) readonly ratingTotal!: Contractor_Rating_Aggregate;

    notRatedText = NOT_RATED;
    badgeColor: typeof BadgeColor = BadgeColor;

    get rating(): number {
      return getContractorRating(this.ratingTotal);
    }
  }
